/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

/**
 * Clicking the "X reviews" count below the header review stars jumps the
 * user to the Reviews accordion (`<details data-pdp-reviews-accordion>`),
 * opens it, and scrolls it into view.
 *
 * Skipped when the count is inside a `<summary>` — the same review-stars
 * snippet is rendered inside the accordion's own summary header for the
 * star + count display, and clicking there should toggle the accordion via
 * the native `<summary>` behavior.
 */
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const count = event.target.closest('.review-stars__count');
  if (!count) return;

  // Inside a <summary> → let native toggle handle it.
  if (count.closest('summary')) return;

  const accordion = document.querySelector('[data-pdp-reviews-accordion]');
  if (!(accordion instanceof HTMLDetailsElement)) return;

  accordion.open = true;
  accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
});
